/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_TeamsInputs */

const th_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีม`)
};

const en_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

const ja_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チーム`)
};

const zh_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球队`)
};

const es_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipos`)
};

const pt_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Times`)
};

const id_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim`)
};

const fr_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipes`)
};

const tl_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga team`)
};

const vi_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đội`)
};

const ko_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀`)
};

const de_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

const ru_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команды`)
};

const tr_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takımlar`)
};

const it_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squadre`)
};

const pl_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drużyny`)
};

const uk_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команди`)
};

const hi_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीमें`)
};

const ar_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفرق`)
};

const ms_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasukan`)
};

const bn_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল`)
};

const zh_tw2_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊`)
};

const zh_hk2_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊`)
};

const ur_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹیمیں`)
};

const fa_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تیم‌ها`)
};

const sw_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timu`)
};

const nl_org_teams = /** @type {(inputs: Org_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

/**
* | output |
* | --- |
* | "Teams" |
*
* @param {Org_TeamsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_teams = /** @type {((inputs?: Org_TeamsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_TeamsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_teams(inputs)
	if (locale === "ja") return ja_org_teams(inputs)
	if (locale === "zh") return zh_org_teams(inputs)
	if (locale === "es") return es_org_teams(inputs)
	if (locale === "pt") return pt_org_teams(inputs)
	if (locale === "id") return id_org_teams(inputs)
	if (locale === "fr") return fr_org_teams(inputs)
	if (locale === "tl") return tl_org_teams(inputs)
	if (locale === "vi") return vi_org_teams(inputs)
	if (locale === "ko") return ko_org_teams(inputs)
	if (locale === "de") return de_org_teams(inputs)
	if (locale === "ru") return ru_org_teams(inputs)
	if (locale === "tr") return tr_org_teams(inputs)
	if (locale === "it") return it_org_teams(inputs)
	if (locale === "pl") return pl_org_teams(inputs)
	if (locale === "uk") return uk_org_teams(inputs)
	if (locale === "hi") return hi_org_teams(inputs)
	if (locale === "ar") return ar_org_teams(inputs)
	if (locale === "ms") return ms_org_teams(inputs)
	if (locale === "bn") return bn_org_teams(inputs)
	if (locale === "zh-TW") return zh_tw2_org_teams(inputs)
	if (locale === "zh-HK") return zh_hk2_org_teams(inputs)
	if (locale === "ur") return ur_org_teams(inputs)
	if (locale === "fa") return fa_org_teams(inputs)
	if (locale === "sw") return sw_org_teams(inputs)
	if (locale === "nl") return nl_org_teams(inputs)
	return en_org_teams(inputs)
});